import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataPointGroupKeys } from '../DataPointGroup';
import { CreateDataPointInput, DeleteDataPointInput, UpdateDataPointInput } from '../generated/graphql';
import { clientCreateDataPoint, clientDeleteDataPoint, clientUpdateDataPoint, useGraphqlClient } from '../graphql';

export const useCreateDataPoint = () => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();

  const createDataPoint = useMutation({
    retry: 3,
    mutationKey: ['createDataPoint'],
    mutationFn: (input: CreateDataPointInput) => {
      return clientCreateDataPoint(gqlClient, input);
    },
    onSuccess({ dataPoint }) {
      queryClient.invalidateQueries(dataPointGroupKeys.dataPointsInGroup(dataPoint.groupID));
    },
  });

  return { createDataPoint };
};

export const useUpdateDataPoint = () => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();

  const updateDataPoint = useMutation({
    retry: 3,
    mutationKey: ['updateDataPoint'],
    mutationFn: (input: UpdateDataPointInput) => {
      return clientUpdateDataPoint(gqlClient, input);
    },
    onSuccess({ dataPoint }) {
      queryClient.invalidateQueries(dataPointGroupKeys.dataPointsInGroup(dataPoint.groupID));
    },
  });
  return { updateDataPoint };
};

export const useDeleteDataPoint = () => {
  const gqlClient = useGraphqlClient();

  const deleteDataPoint = useMutation({
    mutationFn: (input: DeleteDataPointInput) => {
      return clientDeleteDataPoint(gqlClient, input);
    },
  });

  return { deleteDataPoint };
};
